<template>
    <div class="cardContainer">
        <div class="gridWrapper">
            <div v-if="dayList && dayList.length > 0" class="day1Card">
                <div class=" day1Content">
                    <div class="gold-text">{{ $t('common.travel') }} 1</div>
                    <div class="day1-body">
                        <div class="day1-date">{{ dayFormat(dayList[0].date, 0) }}</div>
                        <div class="day1-amount">R$ {{ formatCurrency(dayList[0].amount) }}</div>
                    </div>
                    <div v-if="props.showClickButton" class="availableTitle">{{ $t('activity.available') }} {{ 'R$ ' +
                        formatCurrency(availableValue) }}</div>
                    <div v-if="props.showClickButton" class="resgatar-btn" @click="clickOnButton">{{
                        $t('activity.click') }}</div>
                </div>
            </div>
            <div v-for="(i, index) in dayList?.slice(1)" :key="index" class="dayCard smallCard">
                <div class="dayCardContent">
                    <div class="day-num">{{ $t('common.travel') }} {{ index + 2 }}</div>
                    <img src="@/assets/rechargeGift/lock2.png" width="35%" style="padding: 4px 0 2px;">
                    <div class="dateText">{{ dayFormat(i.date, 0) }}</div>
                    <div class="dateText">{{ formatCurrency(i.amount) }}</div>
                </div>
            </div>

        </div>

        <van-row>
            <van-col span="24">
                <div class="accumulated-bar">
                    <div class="accumulated-text">
                        <span class="label">{{ $t('activity.given') }}:</span>
                        <span class="value gold-text2">R$ {{ formatCurrency(givenValue) }}</span>
                    </div>

                    <div class="money-bag-container">
                        <img src="@/assets/rechargeGift/money_bag2.png" class="money-bag-img">
                    </div>
                </div>
            </van-col>
        </van-row>
    </div>
</template>
<script lang="ts" setup>
import { dayFormat, formatCurrency, getDefaultRewards } from '@/utils/commonFunction';
import { PropType } from 'vue';

const props = defineProps({
    showClickButton: {
        type: Boolean,
    },
    availableValue: {
        type: Number,
        default: () => 0
    },
    givenValue: {
        type: Number,
        default: () => 0
    },
    dayList: {
        type: Array as PropType<(any)[]>,
        default: () => getDefaultRewards()
    },
    createDate: {
        type: String,
        default: () => ""
    },
})
const emits = defineEmits(['getClaim'])

const clickOnButton = () => {
    emits('getClaim')
}

</script>
<style scoped>
.cardContainer {
    color: #fff;
    font-size: 12px;
    margin: 0px 10px 0;
}

.gridWrapper {
    display: grid;
    grid-template-columns: repeat(24, 1fr);
    gap: 8px;
    margin: 0 15px 10px;
}

.day1Card {
    grid-column: span 8;
    grid-row: span 2;
    border: 4px solid #ff90aa;
    box-shadow: 0px 0px 7px 5px rgb(255 170 0 / 30%);
    display: flex;
    border-radius: 15px;
}

.smallCard {
    grid-column: span 4;
    grid-row: span 1;
}

.dayCard {
    background: #281805;
    border-radius: 6px;
    overflow: hidden;
}

.dayCardContent {
    width: 100%;
    height: 100%;
    background: linear-gradient(180deg, #895792 0%, #8f30ff1e 30%, #66402100 70%);
    text-align: center;
    border-radius: 5px;
}

.day1Content {
    width: 100%;
    margin: 3px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    border-radius: 10px;
    background: linear-gradient(180deg, #2309308f 0%, #44144e4a 50%, #1509264a 100%);
    box-shadow: 0px 0px 7px 5px rgb(255 0 249 / 30%);
    border: 0.5px solid rgb(253 96 255 / 39%);
}

.gold-text {
    background:linear-gradient(180deg, #ffa6e1 0%, #fea93c 100%);
    -webkit-background-clip: text;
    background-clip: text;
    -webkit-text-fill-color: transparent;
    color: transparent;
    font-weight: 800;
    font-size: 28px;
    letter-spacing: -1px;
    padding: 5px 0;
    filter: drop-shadow(0px 2px 2px rgba(0, 0, 0, 0.5));
}

.day1-body {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
}

.day1-date {
    color: #8a6c99;
    padding: 5px 0;
}

.day1-amount {
    font-size: 18px;
    background: linear-gradient(180deg, #ffa6e1 0%, #fea93c 100%);
    -webkit-background-clip: text;
    background-clip: text;
    -webkit-text-fill-color: transparent;
    color: transparent;
    font-weight: 800;
}

.resgatar-btn {
    background: linear-gradient(90deg, #9b33dc7d 0%, #40135226 50%, #aa2ff566 100%);
    text-align: center;
    color: #ae5fcc;
    border-radius: 30px;
    padding: 6px 0;
    font-weight: bold;
    font-size: 12px;
    text-transform: uppercase;
    min-width: 90%;
    border: 2px solid #412261;
    margin-top: 2%;
}

.dateText {
    font-size: 11px;
    color: #c4997aac;
    padding-top: 5px;
}

.dayRow {
    display: flex;
    flex-direction: row;
}

.dayColumn {
    display: flex;
    flex-direction: column;
    justify-content: center;
    text-align: center;
    align-items: center;
    border-right: 3px dashed #80808070;
}

.availbleContent {
    display: flex;
    flex-direction: column;
    justify-content: center;
    text-align: center;
    align-items: center;
    padding: 20px 10px 0px;
}

.availableTitle {
    color: #e4adff;
    font-size: 11.5px;
    padding: 5px;
    margin-top: 10%;
}

.day-num {
    background: #020411ed;
    width: 100%;
    border-radius: 5px;
    font-size: 12px;
    color: #8a6c99;
    padding: 5px 0;
}

.dayImage img {
    width: 85%;
}

.dayImage {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    margin-bottom: 5px;
}

.centerAlignment {
    display: flex;
    flex-direction: column;
    justify-content: center;
    text-align: center;
    align-items: center;
}

.dayCard {
    color: #b07f3fe3;
    font-size: 9.5px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    text-align: center;
    min-width: 13%;
    flex-shrink: 0;
    padding: 3px;
    background: #261731;
    border-radius: 5px;
}

.dayCardWrapper {
    display: flex;
    overflow-x: auto;
    white-space: nowrap;
    scrollbar-width: none;
    -ms-overflow-style: none;
    flex: 1;
}

.dayCardWrapper::-webkit-scrollbar {
    display: none;
}

.scrollRow {
    display: flex;
    align-items: center;
    width: 100%;
    position: relative;
    gap: 5px;
}

.arrowLeft img {
    width: 10px;
}

.arrowRight {
    position: absolute;
    right: 0px;
}

.arrowLeft {
    position: absolute;
    left: 0px;
}

.arrowRight img {
    width: 10px;
    transform: rotate(180deg);
}

.dayTitle {
    font-weight: bold;
    padding-bottom: 5px;
}

.rightBorder {
    border-right: 1px solid #80808070;
}

.accumulated-bar {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 5px 15px;
    border-radius: 4px;
    border-top: 1.5px solid;
    border-bottom: 1.5px solid;
    border-image: linear-gradient(90deg, transparent 0%, #aa60d1 50%, transparent 100%) 1;
}

.accumulated-text {
    font-size: 16px;
    font-weight: bold;
    display: flex;
    gap: 8px;
    z-index: 1;
}

.label {
    color: #e1b46a;
    display: flex;
    align-items: center;
}

.gold-text2 {
    background: linear-gradient(180deg, #ffa6e1 0%, #fea93c 100%);
    -webkit-background-clip: text;
    background-clip: text;
    -webkit-text-fill-color: transparent;
    color: transparent;
    font-weight: 800;
    font-size: 16px;
    letter-spacing: -1px;
    filter: drop-shadow(0px 2px 2px rgba(0, 0, 0, 0.5));
}

.money-bag-container {
    position: absolute;
    right: 10%;
    bottom: 0px;
}

.money-bag-img {
    width: 60px;
    display: block;
    filter: drop-shadow(0 4px 8px rgba(0, 0, 0, 0.5));
}
</style>